import * as React from "react";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { isConsolidate, selectedHeadAccounts } from "../../Common/PortfolioDashboardHelper";
import { PresentationContext } from "../../Common/PresentationViewWrapper";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Methods } from "../../../../../../Common/CommonHelper";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { DashboardContents } from "../../../../../../Resoures/DashboardContents";
import { AriaTooltip } from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { AsAtDatePicker } from "../../../../../../Common/AsAtDatePicker";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { UserStore } from "../../../../../../Stroes/Variable";
import { User } from "../../../../../../../../Wrap/Models/Models/User/User";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../../Shared/Common/UserMessages";
import { Urls } from "../../../../../../Urls";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { ThreeDotsDrodpwn } from "./ThreeDotsDropdown";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { PresentationViewButton } from "../../Common/PresentationViewButton";
import { ProductPerformanceModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductPerformanceModel";
import { groupProductDetail } from "../../Common/PortfolioDashboardHelper";
import {
    ConsolidatedAccountStore,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../../Store/Variable";
import CoachMarker from "../../../../../../../Shared/CoachMarkers/CoachMarker";
import { StringHelper } from "../../../../../../../../react-core/Helpers/StringHelper";
import { TrustDetail } from "../../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { SummaryTrustDetailsStore } from "../Store/Variable";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { portfolioDashboardTabEnum } from "../../../Resource/Content";
import {
    ProductValuationDetailSummary
} from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { AccountStatus } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";

interface IAccountsSummaryTableProps {
    onDateChange: (val: Date) => void;
    detailsSummary?: ProductValuationDetailSummary[];
    dateSelect?: Date;
    hierarchyId?: string;
    cssWrapper?: string;
    subAccountData?: any[];
    productPerformanceList: ProductPerformanceModel[];
    hasReadWriteAccessToAdviser: boolean;
    isPresentationClicked: boolean[];
    onPresentationStatusChange: (tabIndex: portfolioDashboardTabEnum, isPresentationClickedPre: boolean[]) => void;
}

interface IAccountsSummaryTableState {
    showLightbox: boolean;
    showWithDrawlRestrictionLightbox: boolean;
    userInfo: User;
    trustDetails: TrustDetail[];
    showReportPop: boolean;
    reportLinkAccount: ClientAccount;
    accountsForReport: ClientAccount[];
}

export class AccountsSummaryTable extends FormComponent<IAccountsSummaryTableProps, IAccountsSummaryTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            showLightbox: false,
            showWithDrawlRestrictionLightbox: false,
            trustDetails: [],
            showReportPop: false,
            reportLinkAccount: null,
            accountsForReport: [],
        };
        this.subscribeToStore(SummaryTrustDetailsStore, () => this.onTrustDetailChange());
    }

    private onTrustDetailChange(): void {
        const result: TrustDetail[] = [];

        SummaryTrustDetailsStore.getAllPayload().forEach((item) => {
            result.concat(item.payload || []);
        });

        this.setState({ trustDetails: result });
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {}

    private stringHelper = new StringHelper();

    private onDateChange(val: Date) {
        this.props.onDateChange(val);
    }

    private getProductTotalGainLoss(valuation: ProductValuationDetailSummary): number {
        const { productPerformanceList } = this.props;

        const performance = productPerformanceList?.find((x) => x.ClAccountId == valuation.ClAccountId);

        return performance ? performance.TotalGainLoss.Amount : 0;
    }

    private static getWithdrawalRestrictionActive(valuation: ProductValuationDetailSummary): boolean {
        return valuation.IsRetrictionActive;
    }

    private renderProductDetailsDom(
        detailsSummary: ProductValuationDetailSummary[]
    ): JSX.Element[] {
        if (detailsSummary && detailsSummary.length > 0) {
            const products: JSX.Element[] = [];
            const groupsProducts = groupProductDetail(
                PortfolioDashboardMultiSelectionStore.getData(),
                PortfolioDashboardStore.getData(),
                detailsSummary,
                "ClAccountId"
            );
            let index = 0;
            Object.keys(groupsProducts).forEach((key) => {
                if (groupsProducts[key]?.length > 0) {
                    products.push(
                        <tr key={key}>
                            <td colSpan={7} className="">
                                {key} account
                            </td>
                        </tr>
                    );
                    products.push(
                        <tr key={key + "hr"}>
                            <td colSpan={7} className="mt-0 mb-0 pt-0 pb-0" style={{ height: "auto" }}>
                                <hr className="mt-0 mb-0" />
                            </td>
                        </tr>
                    );
                }
                groupsProducts[key].forEach((item: ProductValuationDetailSummary) => {
                    const totalGainLoss = MoneyDisplayHelper.getMoneyFormatNoSymbol(this.getProductTotalGainLoss(item));
                    const isWithdrawalRestriction = AccountsSummaryTable.getWithdrawalRestrictionActive(item);
                    let totalGainLossClass = "cell-right ";
                    const accountTypeClass = `account-legend ${this.stringHelper.getDonutClass(item.ProductType)}`;
                    const details = (detailsSummary || []).find((details) => {
                        return details.ClAccountId === item.ClAccountId;
                    });

                    const regularPaymentsIn: boolean = details?.RegularPaymentIns?.length > 0;

                    let iconStyle: JSX.Element;
                    iconStyle = <span className={accountTypeClass}></span>;

                    totalGainLossClass += totalGainLoss >= 0 ? "text-positive" : "text-negative";
                    const product: JSX.Element = (
                        <>
                            <tr key={index}>
                                <td>
                                    {iconStyle}
                                    <span>
                                        {item.ProductType != SubAccountType.Sipp && (
                                            <Permission
                                                userClaim={UserClaim.AdviserPortalClientInvestmentsCanView}
                                                replaceChildren={<button> {item.ProductDisplayName}</button>}
                                            >
                                                <button
                                                    className="hyperlink text-left"
                                                    onClick={() => {
                                                        this.addEvent({
                                                            eventParameters: {
                                                                eventCategory: eventCategoryForGTM.summaryTab,
                                                                eventAction: "summary table",
                                                                eventLabel: item.ProductDisplayName,
                                                            },
                                                            event: "summarytab_interaction",
                                                        });
                                                        Navigator.navigateTo(
                                                            Urls.get()
                                                                .main.PortfolioDashboard({
                                                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                        ContextType.Customer
                                                                    ),
                                                                })
                                                                .productOverView({
                                                                    subaccounthierarchyId: item.SubAccountHierarchyId,
                                                                }).productOverView
                                                        );
                                                    }}
                                                >
                                                    {item.ProductDisplayName}
                                                </button>
                                            </Permission>
                                        )}
                                        {item.ProductType == SubAccountType.Sipp && (
                                            <Permission
                                                userClaim={UserClaim.AdviserPortalDluSippDetailCanView}
                                                replaceChildren={<button> {item.ProductDisplayName}</button>}
                                            >
                                                <button
                                                    className="hyperlink"
                                                    onClick={() => {
                                                        this.addEvent({
                                                            eventParameters: {
                                                                eventCategory: eventCategoryForGTM.summaryTab,
                                                                eventAction: "summary table",
                                                                eventLabel: item.ProductDisplayName,
                                                            },
                                                            event: "summarytab_interaction",
                                                        });
                                                        window.location.assign(StaticUrls.SippDetail(item.ClAccountId));
                                                    }}
                                                >
                                                    {item.ProductDisplayName}
                                                </button>
                                            </Permission>
                                        )}
                                    </span>
                                </td>
                                <td className="cell-center">{item.ClAccountId}</td>
                                <td className="cell-right">{Methods.getPercentageFormat(item.Allocation * 100)}</td>
                                <td className={totalGainLossClass}>
                                    {Methods.getMoneyFormat(
                                        { Amount: totalGainLoss, Currency: CurrencyCode.GBP },
                                        true
                                    )}
                                </td>
                                <td className="cell-right text-highlight text-bold">
                                    {Methods.getMoneyFormat({ Amount: item.TotalValue.Amount, Currency: CurrencyCode.GBP }, false)}
                                </td>

                                <td>{this.renderDotsDropdown(item, regularPaymentsIn, isWithdrawalRestriction)}</td>
                            </tr>
                            {item?.JointAccountHolderNames?.length > 0 && (
                                <tr>
                                    <td className="pl-20">
                                        {AccountsSummaryTable.renderJointAccountHolderName(item?.JointAccountHolderNames)}
                                    </td>
                                </tr>
                            )}
                        </>
                    );
                    index = index + 1;
                    products.push(product);
                });
            });

            return products;
        } else {
            return null;
        }
    }

    private getTotalValue(productValuationList: Array<ProductValuationDetailSummary>): number {
        let totalValue = 0;
        productValuationList.forEach((item) => {
            totalValue += Math.round(item.TotalValue.Amount * 10000) / 10000;
        });
        return totalValue;
    }

    private static renderJointAccountHolderName(arr: Array<string>) {
        return arr[0] + (arr[1] ? ` & ${arr[1]}` : "");
    }

    private renderDotsDropdown(item: ProductValuationDetailSummary, RegularPaymentsIn: boolean, isWithdrawalRestriction: boolean) {
        // let textLinks = [];
        const subAccount = this.props.subAccountData?.filter((v) => {
            return v.ClAccountId === item.ClAccountId;
        });
        const subAccountHierarchyId = CommonHelper.isNullOrEmpty(item.SubAccountHierarchyId)
            ? subAccount.length > 0
                ? subAccount[0].HierarchyId
                : ""
            : item.SubAccountHierarchyId;
        const headAccountHierarchyId = CommonHelper.isNullOrEmpty(item.HeadAccountHierarchyId)
            ? getQueryParameters()["hierarchyid"]
            : item.HeadAccountHierarchyId;

        var isClosingAccount = subAccount && subAccount[0] && subAccount[0].Status == AccountStatus.Closing

        return (
            !UserStore.getUserInfo()?.IsReadOnly &&
            this.props.hasReadWriteAccessToAdviser == true && !isClosingAccount && (
                <ThreeDotsDrodpwn
                    isAppStoreEnabled={this.state.userInfo?.IsAppStoreEnabledForUser}
                    data={item}
                    headAccountHierarchyId={headAccountHierarchyId}
                    subAccountHierarchyId={subAccountHierarchyId}
                    regularPaymentsIn={RegularPaymentsIn}
                    isWithDrawalRestriction={isWithdrawalRestriction}
                    restrictWithdrawal={() => this.setState({ showWithDrawlRestrictionLightbox: true })}
                    prohibitedWithdrawal={() => this.setState({ showLightbox: true })}
                    trustDetail={this.state.trustDetails.find(
                        (ele) => ele.ClAccountId == item.ClAccountId.split("-")[0]
                    )}
                    buttonTitle="Quick actions menu"
                />
            )
        );
    }

    private static handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}

        (window as any).AppStore.open(context);
    }

    private handleCreateClientPortfolioReportClick() {
        let accounts = selectedHeadAccounts(
            PortfolioDashboardMultiSelectionStore.getData(),
            PortfolioDashboardStore.getData()
        );
        if (isConsolidate()) {
            accounts = [ConsolidatedAccountStore.getData()].concat(accounts);
        }
        if (accounts.length == 1) {
            if (checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite))
                {Navigator.navigateTo(
                    Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                        })
                        .clientReport({
                            headaccounthierarchyId: accounts[0].HierarchyId,
                        }).clientReport
                );}
        } else {
            this.setState({ showReportPop: true, accountsForReport: accounts });
        }
    }

    public render(): JSX.Element {
        const { detailsSummary, dateSelect, hierarchyId, productPerformanceList } = this.props;
        const { isPresentationView } = this.context;
        let totalGain = 0;
        productPerformanceList
            .filter((p) => detailsSummary.some((x) => x.ClAccountId == p.ClAccountId))
            .map((value) => (totalGain = totalGain + value.TotalGainLoss.Amount));
        let totalColor = totalGain < 0 ? "color-11" : "color-20";
        totalColor = "cell-right " + totalColor;
        this.stringHelper = new StringHelper();
        let restrictedMessage = "An account with suspended or restricted activities cannot setup withdrawals.";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        return (
            <>
                <div className="row mb-13">
                    <div className="col-12 col-xs-auto">
                        <AsAtDatePicker
                            selected={dateSelect}
                            accountViewSelected={hierarchyId}
                            onChange={(d) => {
                                this.addEvent({
                                    event: "summarytab_interaction",
                                    eventParameters: {
                                        eventCategory: eventCategoryForGTM.summaryTab,
                                        eventAction: "interactions",
                                        eventLabel: "date widget",
                                    },
                                });
                                this.onDateChange(d);
                            }}
                            cssWrapper="label-sr-only"
                        />
                    </div>
                    <div className="col-12 col-xs-fluid col-middle">
                        <div className="row row-right mb-18">
                            {!isPresentationView && (
                                <Permission userClaim={UserClaim.AdviserPortalClientPortfolioReportReadWrite}>
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="document-button"
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "summarytab_interaction",
                                                    eventParameters: {
                                                        eventCategory: eventCategoryForGTM.summaryTab,
                                                        eventAction: "interactions",
                                                        eventLabel: "create client portfolio report",
                                                    },
                                                });
                                                this.handleCreateClientPortfolioReportClick();
                                            }}
                                        >
                                            <span className="icon" aria-hidden="true"></span>Create client portfolio
                                            report
                                        </button>
                                    </div>
                                </Permission>
                            )}

                            <PresentationViewButton
                                onClick={() => {
                                    this.addEvent({
                                        event: "summarytab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.summaryTab,
                                            eventAction: "interactions",
                                            eventLabel: "presentation mode",
                                        },
                                    });
                                    this.props.onPresentationStatusChange(
                                        portfolioDashboardTabEnum.Summary,
                                        this.props.isPresentationClicked
                                    );
                                }}
                            />
                            <CoachMarker coachMarkerKey="portfoliosummary-presentation" />
                            {isAppStoreEnabled && (
                                <>
                                    <div className="col-sm-auto">
                                        <button
                                            type="button"
                                            className="applications-pad-button"
                                            onClick={AccountsSummaryTable.handleLaunchpadClick.bind(this)}
                                        >
                                            <span className="sr-only">Applications pad</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                    <CoachMarker coachMarkerKey="portfoliosummary-launchapps" />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <table className="accounts-table">
                    <thead>
                        <tr>
                            <th className="">Product</th>
                            <th className="cell-center">Account number</th>
                            <th className="cell-right">Allocation</th>
                            <th className="cell-right">
                                Change £
                                <AriaTooltip
                                    cssWrapper="is-info-icon ml-6"
                                    showCloseButton={true}
                                    title="More about £ change on the account"
                                >
                                    <div className="text-left">{DashboardContents.ChangeInValueTooltip1}</div>
                                    <br />
                                    <div className="text-left">{DashboardContents.ChangeInValueTooltip2}</div>
                                </AriaTooltip>
                            </th>
                            <th className="cell-right">Value</th>
                            <th className="cell-center">
                                <span className="sr-only">More options</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>{this.renderProductDetailsDom(detailsSummary)}</tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td></td>
                            <td className="cell-right">{detailsSummary ? Methods.getPercentageFormat(100) : null}</td>
                            <td className={totalColor}>
                                {detailsSummary
                                    ? Methods.getMoneyFormat({ Amount: totalGain, Currency: CurrencyCode.GBP }, true)
                                    : null}
                            </td>
                            <td className="cell-right">
                                {detailsSummary
                                    ? Methods.getMoneyFormat(
                                          {
                                              Amount: this.getTotalValue(detailsSummary),
                                              Currency: CurrencyCode.GBP,
                                          },
                                          false
                                      )
                                    : null}
                            </td>
                            <td className="cell-center"></td>
                        </tr>
                    </tfoot>
                </table>
                {this.state.showLightbox && (
                    <Lightbox
                        show={this.state.showLightbox}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showLightbox: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>If you wish to take a withdrawal from a bond, please contact the Wrap Customer Centre.</p>
                        <button className="btn primary" onClick={() => this.setState({ showLightbox: false })}>
                            OK
                        </button>
                    </Lightbox>
                )}
                {this.state.showWithDrawlRestrictionLightbox && (
                    <Lightbox
                        show={this.state.showWithDrawlRestrictionLightbox}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showWithDrawlRestrictionLightbox: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>{restrictedMessage}</p>
                        <button
                            className="btn primary"
                            onClick={() => this.setState({ showWithDrawlRestrictionLightbox: false })}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}

                {!isPresentationView && this.state.showReportPop && (
                    <Lightbox
                        title="Select an account to create report"
                        show={this.state.showReportPop}
                        cssWrapper="is-default-lightbox"
                        onClose={() => this.setState({ showReportPop: false, reportLinkAccount: null })}
                    >
                        <SelectEditor
                            onChange={(v) => this.setState({ reportLinkAccount: v })}
                            options={this.state.accountsForReport}
                            placeholder="Please select"
                            selected={this.state.reportLinkAccount}
                            cssWrapper={"control-size-245"}
                            getText={(o) => o?.HeadClAccountId}
                        />
                        {checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite) && (
                            <button
                                className="btn primary"
                                disabled={this.state.reportLinkAccount == null}
                                onClick={() =>
                                    Navigator.navigateTo(
                                        Urls.get()
                                            .main.PortfolioDashboard({
                                                hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                            })
                                            .clientReport({
                                                headaccounthierarchyId: this.state.reportLinkAccount.HierarchyId,
                                            }).clientReport
                                    )
                                }
                            >
                                Create Client Portfolio Report
                            </button>
                        )}
                    </Lightbox>
                )}
            </>
        );
    }
}

AccountsSummaryTable.contextType = PresentationContext;
